import Swiper from 'swiper/bundle';
import kr from '../kr/kr';

export default class openDetails extends kr.Component {
    init() {
        this.buttonDetails = document.querySelector('.slider-button--details');
        this.buttonBack = document.querySelector('.section-details__button');
        this.detailsSection = document.querySelector('.section-details');
        this.productSlider = document.querySelector('.product-slider');

        this.buttonDetails.addEventListener('click', () => {
            this.openDetails();
        });

        this.buttonBack.addEventListener('click', () => {
            this.closeDetails();
        });

        this.initSwiper();
    }

    initSwiper() {
        const swiper = new Swiper(".swiper-bottom", {
            spaceBetween: 10,
            freeMode: true,
            watchSlidesProgress: true,
            observer: true,
            observeParents: true,
            centerInsufficientSlides: true,
    
            breakpoints: {
                0: {
                    slidesPerView: 4,
                },
            }
        });
        
        const swiperMain = new Swiper(".swiper-main", {
            loop: true,
            spaceBetween: 10,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            thumbs: {
                swiper: swiper,
            },
            observer: true,
            observeParents: true,
        });
    }

    openDetails() {
        this.detailsSection.classList.add('active');
        this.buttonDetails.classList.add('hidden');
        this.productSlider.classList.add('hidden');
    }

    closeDetails() {
        this.detailsSection.classList.remove('active');
        this.buttonDetails.classList.remove('hidden');
        this.productSlider.classList.remove('hidden');
    }
}

kr.registerComponent('.section-details', {
    component: openDetails
});